import axios from "axios";
import { useEffect, useState } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export function formatPrice(cents, currency = "eur") {
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: currency.toUpperCase() }).format((cents || 0) / 100);
}

export function useContent() {
  const [content, setContent] = useState({});
  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
  }, []);
  return content;
}

export async function createCheckout(slug, billing = null) {
  const { data } = await api.post("/payments/checkout", { slug, origin_url: window.location.origin, billing });
  return data.checkout_url;
}

export function goToCheckout(url) {
  try {
    if (window.top !== window.self) {
      window.top.location.href = url;
      return;
    }
  } catch (e) {
    // cross-origin iframe: fall through
  }
  window.location.href = url;
}
